// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.loadPackageJson = loadPackageJson;
exports.loadTeamsFxDevScript = loadTeamsFxDevScript;
const tslib_1 = require("tslib");
const fs = tslib_1.__importStar(require("fs-extra"));
const path = tslib_1.__importStar(require("path"));
async function loadPackageJson(path, logger) {
    if (!(await fs.pathExists(path))) {
        logger?.error(`Cannot load package.json from ${path}. File not found.`);
        return undefined;
    }
    const rpj = require("read-package-json-fast");
    try {
        return await rpj(path);
    }
    catch (error) {
        logger?.error(`Cannot load package.json from ${path}. Error: ${error}`);
        return undefined;
    }
}
async function loadTeamsFxDevScript(componentRoot) {
    const packageJson = await loadPackageJson(path.join(componentRoot, "package.json"));
    if (packageJson && packageJson.scripts && packageJson.scripts["dev:teamsfx"]) {
        const devTeamsfx = packageJson.scripts["dev:teamsfx"];
        return devTeamsfx;
    }
    else {
        return undefined;
    }
}
//# sourceMappingURL=packageJsonHelper.js.map